import React from "react"
import {findDOMNode} from "react-dom"
import Popover from "../../../../../core/gd-components/gd-popover/popover";
import PersonalView from "../../../../../core/model2/view/personal-view/personal-view";
import NavigationMenuItemPersonalView from "./personal-view";
import {ViewType} from "../../../../../core/gd/const/views/view-type";
import {PopoverAttachmentType} from "../../../../../core/gd-components/gd-popover/@const";

type Props = {
    parentRef?          : any

    attachment?         : string
    targetAttachment?   : string
    // attachmentType?     : PopoverAttachmentType
    offset?             : string
    targetOffset?       : string

    height?             : number

    getTargetFunc       : func
    hidePopover         : func
}

// const debug = "AddViewPopover"
const debug = false

export default function NavigationMenu_PersonalViewsMorePopover(props:Props) {

    const onClickOutside = (e: React.SyntheticEvent) => {
        const ignoreClick = !!gd.utils.Dom.findNodeByClassName(e.target, ["ui5-popover-menu", "ui-context-menu"])

        debug && console.log(debug, 'onClickOutside', ignoreClick, e.target)

        if (!ignoreClick) {
            props.hidePopover()
        }
    }

    const popoverStyle: any = {}
    if (props.height) {
        popoverStyle.height = props.height
    }

    if (props.parentRef.current) {
        const parentNode: any = findDOMNode(props.parentRef.current)
        popoverStyle.width = _.max([180, parentNode.clientWidth])
    }

    const options : Option[] = []

    const views : PersonalView[] = gd.user.personalViews.homeMoreViews


    // lets split into groups ...

    // const group3 = _.filter(views, (view: PersonalView) => {
    const group2 = _.remove(views, (view: PersonalView) => {
        return [ViewType.MY_TIME, ViewType.MY_GOALS, ViewType.MY_DOCUMENTS, ViewType.MY_MEETINGS].includes(view.type)
    })


    const group3 = _.remove(views, (view: PersonalView) => {
        return [ViewType.MY_ATTENDANCE, ViewType.MY_NOTES, ViewType.MY_RECENT].includes(view.type)
    })

    const hasGroup1Views = !_.isEmpty(views)
    const hasGroup2Views = !_.isEmpty(group2)
    const hasGroup3Views = !_.isEmpty(group3)

    const showSeparator1 = hasGroup1Views && hasGroup2Views
    const showSeparator2 = (hasGroup1Views || hasGroup2Views) && hasGroup3Views

    return (
        <Popover popoverContentStyle={popoverStyle}
                 constraints={[{
                     to: 'window',
                     attachment: 'together',
                     pin: true
                 }]}
                 attachment={props.attachment}
                 targetAttachment={props.targetAttachment}
                 attachmentType={PopoverAttachmentType.HORIZONTAL}
                 offset={props.offset}
                 targetOffset={props.targetOffset}
                 arrowsVersion={2}
                 arrowsCustomStyles={{
                     'top left bottom left': {
                         left: '22px'
                     },
                     'bottom left top left': {
                         left: '22px'
                     }
                 }}
                 getTargetFunc={props.getTargetFunc}
                 onClickOutside={onClickOutside}>

            <div className="ui5-menu p-b-10">
                {_.map(views, (view, key: number) => {
                    return <NavigationMenuItemPersonalView className="m-l-10 m-r-10 p-l-10 p-r-10"
                                                           view={view}
                                                           hidePopover={props.hidePopover}
                                                           navigationSection={gd.layout.navigation.navigationStructure.home}
                                                           iconMoreClass="i5-pin"
                                                           key={key}/>
                })}

                {showSeparator1 && <div className="separator-h"/>}

                {_.map(group2, (view, key: number) => {
                    return <NavigationMenuItemPersonalView className="m-l-10 m-r-10 p-l-10 p-r-10"
                                                           view={view}
                                                           hidePopover={props.hidePopover}
                                                           navigationSection={gd.layout.navigation.navigationStructure.home}
                                                           iconMoreClass="i5-pin"
                                                           key={key}/>
                })}

                {showSeparator2 && <div className="separator-h"/>}

                {_.map(group3, (view, key: number) => {
                    return <NavigationMenuItemPersonalView className="m-l-10 m-r-10 p-l-10 p-r-10"
                                                           view={view}
                                                           hidePopover={props.hidePopover}
                                                           navigationSection={gd.layout.navigation.navigationStructure.home}
                                                           iconMoreClass="i5-pin"
                                                           key={key}/>
                })}
            </div>
        </Popover>
    )
}
